import { render, staticRenderFns } from "./CardImage.vue?vue&type=template&id=0e4edaaa&"
import script from "./CardImage.vue?vue&type=script&lang=js&"
export * from "./CardImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/Kristian/Local Sites/boligvelger/app/public/wp-content/plugins/ensign-boligprosjekter-blocks/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e4edaaa')) {
      api.createRecord('0e4edaaa', component.options)
    } else {
      api.reload('0e4edaaa', component.options)
    }
    module.hot.accept("./CardImage.vue?vue&type=template&id=0e4edaaa&", function () {
      api.rerender('0e4edaaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CardImage.vue"
export default component.exports